import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Route, Switch, Router, withRouter } from 'react-router-dom'
import AccountIcon from '../../utils/assets/account-white.png';
import FamilyIcon from '../../utils/assets/family-blue.png';
import ProfileIcon from '../../utils/assets/profile-blue.png';
import Label from '../../utils/constants/labels'
import ALLMFTransaction from '../../containers/trading/allmftransaction';
import { ClickAwayListener } from '@material-ui/core';

import PortfolioImageNormal from '../../utils/assets/images/img7.png'
import PortfolioImageHover from '../../utils/assets/images/img7-3.png'
import PortfolioImageClick from '../../utils/assets/images/img7-2.png'
import ReportsNormal from '../../utils/assets/images/img8-2.png'
import ReportsHover from '../../utils/assets/images/img8-3.png'
import ReportsClick from '../../utils/assets/images/img8-2.png'
import BuysellNormal from '../../utils/assets/images/img9.png'
import BuysellHover from '../../utils/assets/images/img9-3.png'
import BuysellClick from '../../utils/assets/images/img9-2.png'

const styles = theme => ({
    root: {
        width: '100%',
        maxWidth: '85px',
        top: '40%',
        marginTop: '-3.5em',
        backgroundColor: window.globalConfig.color.WHITE,
        position: 'fixed',
        boxShadow: '0 3px 20px 0 rgba(19, 89, 161, 0.1)',
        zIndex: 32,
        padding: 0,
        borderRadius: '0px 9px 0px 0px',
        [theme.breakpoints.down("800")]: {
            top: 'unset',
            bottom: 0,
            justifyContent: 'center',
            backgroundColor: 'unset',
            display: 'flex',
            boxShadow: 'none',
        },
    },

    menuItem: {
        width: '80px',
        minHeight: '65px',
        textAlign: 'center',
        backgroundColor: window.globalConfig.color.WHITE,
        color: window.globalConfig.color.BLACK_PRIMARY,
        borderBottom: `1px solid ${window.globalConfig.color.BORDER}`,
        fontSize: '11px',
        lineHeight: 1.36,
        paddingTop: '17px',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: window.globalConfig.color.RosyBrown,
            color: window.globalConfig.color.BROWN,
        },
        [theme.breakpoints.down("800")]: {
            borderRight: `1px solid ${window.globalConfig.color.BORDER}`,
        },
    },

    activeItem: {
        backgroundColor: window.globalConfig.color.BROWN,
        color: window.globalConfig.color.WHITE,
        '&:hover': {
            backgroundColor: window.globalConfig.color.BROWN,
            color: window.globalConfig.color.WHITE,
        },
    },

    icon: {
        height: 28,
        marginBottom: 5,
    },

    label: {
        fontSize: '10px',
        marginTop: '5px',
        [theme.breakpoints.down("800")]: {
            fontSize: '12px',
        },
    },

    submenu: {
        backgroundColor: '#f9f9f9',
        fontSize: '10px',
        borderTop: `1px solid ${window.globalConfig.color.BORDER}`,
        paddingBottom: '5px',
    },

    submenuItem: {
        padding: '5px 0',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#eee',
        },
    },
    display: {
        display: "inline-block",
        // width: 100,
        marginLeft: -13,
        textAlign: "center",
        [theme.breakpoints.between("350", "400")]: {
            // width: 'unset',
            whiteSpace: 'nowrap',
            display: 'flex',
            flexDirection: 'row',
            width: 115,
            paddingLeft: 20
        },
        [theme.breakpoints.between("400", "600")]: {
            // width: 'unset',
            whiteSpace: 'nowrap',
            display: 'flex',
            flexDirection: 'row',
            width: 125,
            paddingLeft: 20
        }
    },
    img: {
        height: 28,
    },
    heading: {
        fontSize: "10px",
        marginTop: "1em",
        textDecoration: 'none',
        [theme.breakpoints.down("800")]: {
            //marginTop: "unset",
            marginTop: "5px",
            fontSize: "12px",
            lineHeight: "none"
        },
    },

    link: {

        textDecoration: 'none',
        color: window.globalConfig.color.LABLE_GRAY,
        [theme.breakpoints.down("600")]: {
            backgroundColor: window.globalConfig.color.WHITE,
        },
    },
    popover: {
        cursor: "pointer",
        borderRadius: "0px !important",
    },
    paper: {
        borderTopLeftRadius: "5px !important",
        borderTopRightRadius: "5px !important",
        [theme.breakpoints.down("600")]: {
            top: '128vw !important',
            // position:'relative',
        }
    },
    popup: {
        backgroundColor: window.globalConfig.color.WHITE,
        fontSize: 10,
        width: 200,
        borderTopRightRadius: 10,
        borderBottomRightRadius: 10,
        [theme.breakpoints.down("600")]: {
            width: 167,
            borderRadius: 10,

        },
    },
    list: {
        cursor: "pointer",

        [theme.breakpoints.down("600")]: {
            width: 165,
            borderRadius: 10,

        },
    },

    header: {
        backgroundColor: window.globalConfig.color.PRIMARY,
        color: "white",
        height: 50,
        fontWeight: 500
    },
    txtHeader: {
        padding: 15,
    },
    linkContainer: {
        maxHeight: '26vw', overflowY: "scroll",
        [theme.breakpoints.down("600")]: {
            maxHeight: '100vw',
        }
    },
    submenucontainer: {
        [theme.breakpoints.down("600")]: {
            top: '-54vh !important',
            left: "0px !important",
            height: '54vh',
            overflow: "scroll",
            width: "60vw !important"
        }
    }, mainmenucontainer: {
        [theme.breakpoints.down("600")]: {
            left: "-40vw !important", top: "-15vh !important",
            width: "60vw !important"
        }

    }
    , showcontainer: {
        display: "block"
    }, hidecontainer: {
        display: "none"
    },
    firstmenu: {
        borderTopRightRadius: "8px",
        [theme.breakpoints.down("800")]: {
            borderTopRightRadius: "0px",
            borderRight: `1px solid ${window.globalConfig.color.BORDER}`

        }
    },
    secondmenu: {
        [theme.breakpoints.down("800")]: {
            // borderTopRightRadius:"0px",
            borderRight: `1px solid ${window.globalConfig.color.BORDER}`

        }
    },
    labscreen: {
        [theme.breakpoints.down("800")]: {
            backgroundColor: window.globalConfig.color.WHITE,
            boxShadow: "0 3px 20px 0 rgba(19, 89, 161, 0.1)"
        }
    },
    navLeftFix: {
        position: "fixed",
        top: "50%",
        zIndex: 22,
        marginTop: -120,
        boxShadow: "0 3px 20px 0 rgb(19 89 161 / 10%)",
        borderTopRightRadius: 9,
        borderBottomRightRadius: 9,
        [theme.breakpoints.down("920")]: {
            display: "none",
        }

    },
    boxStyle: {
        width: '80px',
        height: '65px',
        display: "block",
        textAlign: "center",
        backgroundColor: window.globalConfig.color.WHITE,
        color: window.globalConfig.color.BLACK_PRIMARY,
        borderBottom: `1px solid ${window.globalConfig.color.BORDER}`,
        fontSize: "11px",
        lineHeight: 1.36,
        paddingTop: "17px",
        cursor: "pointer",
        '&:hover': {
            backgroundColor: window.globalConfig.color.RosyBrown,
            color: window.globalConfig.color.BROWN
        },
        [theme.breakpoints.down("800")]: {
            borderRight: `1px solid ${window.globalConfig.color.BORDER}`,
        }


    },
    blockedboxStyle: {
        width: '80px',
        height: '65px',
        display: "block",
        textAlign: "center",
        backgroundColor: window.globalConfig.color.WHITE,
        color: window.globalConfig.color.BLACK_PRIMARY,
        borderBottom: `1px solid ${window.globalConfig.color.BORDER}`,
        fontSize: "11px",
        lineHeight: 1.36,
        paddingTop: "17px",
        cursor: "not-allowed",

        [theme.breakpoints.down("800")]: {
            borderRight: `1px solid ${window.globalConfig.color.BORDER}`,
        }
    },
    portfolioContainer: {
        '&:hover': {
            color: window.globalConfig.color.BROWN
        }
    },
    navDropBox: {
        //  display: 'none',
        width: 152,
        boxShadow: "7px 7px 20px 0 rgb(0 0 0 / 20%)",
        position: "absolute",
        top: "-203px",
        left: '80px',
        cursor: "pointer",
        [theme.breakpoints.down("800")]: {
            top: "auto",
            bottom: '15vh',
            left: '-57px',
            width: 202,
            // marginLeft:"-67px"
            zIndex: 9,
            cursor: "default"
        },
        [theme.breakpoints.down("600")]: {
            top: "auto",
            bottom: 82,
            left: '-6vw',
            width: 202,
            // marginLeft:"-67px"
            zIndex: 9,
            cursor: "default"
        }
    },
    navDropBoxtwo: {
        //  display: 'none',
        width: 202,
        boxShadow: "7px 7px 20px 0 rgb(0 0 0 / 20%)",
        position: "absolute",
        top: '0px',
        left: '242px',
        maxHeight: 280,
        overflowY: "scroll",
        overflowX: "hidden",
        overflowX: 'none',
        cursor: "pointer",
        [theme.breakpoints.down("800")]: {
            top: "auto",
            bottom: '38vh',
            left: '-54px',
            maxHeight: 293,
            // marginLeft:"-67px"
            zIndex: 9,
            cursor: "default"
        },
        [theme.breakpoints.down("600")]: {
            top: "auto",
            bottom: '38vh',
            left: '-5vw',
            maxHeight: 250,
            zIndex: 9,
            cursor: "default"

        }
    },
    navDropBoxList: {
        width: "87%",
        height: 40,
        lineHeight: 3,
        borderBottom: `1px solid ${window.globalConfig.color.BORDER}`,
        padding: 0,
        textAlign: "left",
        paddingLeft: 30,
        fontSize: 14,
        backgroundColor: window.globalConfig.color.WHITE,
        // overflowY: "scroll",
        // overflowX: "hidden",
        color: window.globalConfig.color.BLACK_PRIMARY,
        '&:hover': {
            backgroundColor: window.globalConfig.color.RosyBrown,
            color: window.globalConfig.color.BROWN
        }

    },
    selectedList: {
        backgroundColor: window.globalConfig.color.BROWN,
        color: window.globalConfig.color.WHITE,
        '&:hover': {
            backgroundColor: window.globalConfig.color.BROWN,
            color: window.globalConfig.color.WHITE,
        }
    },
    listStyle: {
        position: "relative",
        [theme.breakpoints.down("800")]: {
            float: "left"
        }
    },
    topRadius: {
        borderTopRightRadius: 9,
        [theme.breakpoints.down("800")]: {
            borderTopRightRadius: 0,
            borderTopLeftRadius: 9,
        }
    },
    bottomRadius: {
        borderBottomRightRadius: 9,
        [theme.breakpoints.down("800")]: {
            borderBottomRightRadius: 0,
            borderTopRightRadius: 9,
        }
    },
    PortfolioImage: {

        "& span": {
            height: 27,
            display: "block",
            marginBottom: "8px",
            width: "100%",
            background: `url(${PortfolioImageNormal}) no-repeat center top`,

        },
        '&:hover': {
            "& span": {
                height: 27,
                display: "block",
                marginBottom: "8px",
                width: "100%",
                background: `url(${PortfolioImageHover}) no-repeat center top`,
            },
        }

    },
    blockedPortfolioImage: {

        "& span": {
            height: 27,
            display: "block",
            marginBottom: "8px",
            width: "100%",
            background: `url(${PortfolioImageNormal}) no-repeat center top`,

        },
    },
    ReportStyle: {
        "& span": {
            height: 27,
            display: "block",
            marginBottom: "8px",
            width: "100%",
            background: `url(${ReportsNormal}) no-repeat center top`,

        },
        '&:hover': {
            "& span": {
                height: 27,
                display: "block",
                marginBottom: "8px",
                width: "100%",
                background: `url(${ReportsHover}) no-repeat center top`,
            },
        }

    },
    blockedReportStyle: {
        "& span": {
            height: 27,
            display: "block",
            marginBottom: "8px",
            width: "100%",
            background: `url(${ReportsNormal}) no-repeat center top`,

        },
    },
    BuysellStyle: {
        "& span": {
            height: 27,
            display: "block",
            marginBottom: "8px",
            width: "100%",
            background: `url(${BuysellNormal}) no-repeat center top`,

        },
        '&:hover': {
            "& span": {
                height: 27,
                display: "block",
                marginBottom: "8px",
                width: "100%",
                background: `url(${BuysellHover}) no-repeat center top`,
            },
        }

    },
    mutualfundTopSpace: {
        overflowX: 'hidden',
        [theme.breakpoints.up(900)]: {
            marginTop: "-253%"
        }

    },
    equityTopSpace: {
        overflowX: 'hidden',
        [theme.breakpoints.up(900)]: {
            marginTop: "-200%"
        }

    },
    bondsTopSpace: {
        overflowX: 'hidden',
        [theme.breakpoints.up(900)]: {
            marginTop: "-150%"
        }
    },

    GBTopSpace: {
        overflowX: 'hidden',
        [theme.breakpoints.up(900)]: {
            marginTop: "60%"
        }
    },
    FDTopSpace: {
        overflowX: 'hidden',
        [theme.breakpoints.up(900)]: {
            marginTop: "-103%"
        }
    },

    AifTopSpace: {
        overflowX: 'hidden',
        [theme.breakpoints.up(900)]: {
            marginTop: "-50%"
        }
    },
    NPSTopSpace: {
        overflowX: 'hidden',
        [theme.breakpoints.up(900)]: {
            marginTop: "100%"
        }
    },
    Structured: {
        overflowX: 'hidden',
        [theme.breakpoints.up(900)]: {
            marginTop: "258%"
        }

    },
    InsuranceTopSpace: {
        overflowX: 'hidden',
        [theme.breakpoints.up(900)]: {
            marginTop: "150%"
        }
    },
    RealEstateTopSpace: {
        overflowX: 'hidden',
        [theme.breakpoints.up(900)]: {
            marginTop: "3%"
        }
    },
    tradeTopSpace: {
        [theme.breakpoints.up(900)]: {
            marginTop: "150%",
            overflowX: 'hidden',
        }
    }
});

class FamilyReportSideMenu extends React.Component {
    state = {
        activeIndex: 0,
        expandedIndex: null, // to toggle submenu visibility
    };

    handleClick = (index, path) => {

        this.setState({ activeIndex: index });
        this.props.history.push(path);
    };

    toggleSubMenu = (index) => {

        this.setState(prev => ({
            expandedIndex: prev.expandedIndex === index ? null : index
        }));
    };

    componentDidMount() {
        const currentUrl = window.location.pathname;

        if (currentUrl === "/user/allmfTransaction") {
            this.setState({ activeIndex: 1 });
        }
    }

    handleTradeClick = (value) => {

        this.setState({ index: 6, activeIndex: 1, reportOpen: false, mutualfundsOpen: false, openMfTrading: false })
        if (value === "MF Order Status") {
            // this.props.getTransactionOrderReport(this.props.logindetails.SessionID, this.props.logindetails.ClientID, moment().format("YYYY-MM-DD"))
            this.props.history.push({
                pathname: Label.Path.ALLMFTransaction,
                state: { data: "MF Order Status", tabValue: 0 }
            })

            //    this.handleImage(1)
        }
        else if (value === "Upcoming SIPs") {
            // 
            this.props.history.push({
                pathname: Label.Path.ALLMFTransaction,
                state: { data: "Upcoming SIPs", tabValue: 1 }
            })
            this.setState({ index: 6, reportOpen: false, mutualfundsOpen: false })
        }

        else if (value === "Mandate") {
            this.props.history.push({
                pathname: Label.Path.ALLMFTransaction,
                state: {
                    data: "Mandate",
                    tabValue: 2
                }
            })
            this.setState({ index: 6, reportOpen: false, mutualfundsOpen: false })

        }
        else if (value === "Online SIPs") {
            this.props.history.push({
                pathname: Label.Path.ALLMFTransaction,
                state: {
                    data: "Online SIPs",
                    tabValue: 3
                }
            })
            this.setState({ index: 6, reportOpen: false, mutualfundsOpen: false })
            //this.handleImage(1)
        }
        else if (value === "Online STPs") {
            this.props.history.push({
                pathname: Label.Path.ALLMFTransaction,
                state: {
                    data: "Online STPs",
                    tabValue: 4
                }
            })
            this.setState({ index: 6, reportOpen: false, mutualfundsOpen: false })
            //this.handleImage(1)
        }

    }

    render() {
        const { classes } = this.props;
        const { activeIndex, expandedIndex } = this.state;

        console.log(activeIndex);

        const TradingTabdata = [
            {
                id: "1",
                tabTitle: "MF Order Status",
                tabContent: "MFOrderStatus",
            },
            {
                id: "2",
                tabTitle: "Upcoming SIPs",
                tabContent: "UpcomingSIPs",
            },
            {
                id: "3",
                tabTitle: "Mandate",
                tabContent: "Mandate",
            },
            {
                id: "4",
                tabTitle: "Online SIPs",
                tabContent: "OnlineSips",
            },
            {
                id: "5",
                tabTitle: "Online STPs",
                tabContent: "OnlineStps",
            },
        ];

        const menuItems = [
            {
                label: 'Portfolio',
                icon: PortfolioImageClick,
                path: '/familyreport',
                submenus: false
            },
            {
                label: 'MF Trading',
                icon: ReportsNormal,
                path: '/user/allmfTransaction',
                submenus: TradingTabdata,

            }
        ];

        return (
            <div className={classes.root}>
                <Router history={this.props.history}>
                    <Switch>
                        {/*<Route path={Label.Path.ALLMFTransaction} render={(props) => (
                            <ALLMFTransaction {...props} />
                        )} />*/}
                    </Switch>

                    {/*menuItems.map((item, index) => (
                        <div key={index}>
                            <div
                                className={`${classes.menuItem} ${activeIndex === index ? classes.activeItem : ''}`}
                                onClick={() => {
                                    //this.handleClick(index, item.path);
                                    this.toggleSubMenu(index);
                                }}
                            >
                                <img src={item.icon} alt={item.label} className={classes.icon} />
                                <div className={classes.label}>{item.label}</div>
                            </div>
                            {expandedIndex === index && item.submenus && (
                                <div className={classes.navDropBox}
                                    style={{ top: -70 }}
                                >
                                    {item.submenus.map((sub, sidx) => (
                                        <div key={sidx} className={[classes.navDropBoxList].join(' ')} onClick={() => {
                                            this.handleTradeClick(sub.tabTitle)
                                        }
                                        }>
                                            {sub.label}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))*/}
                    <div className={classes.navLeftFix}>
                        <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
                            {menuItems.map((item, index) => (
                                <li
                                    key={index}
                                    onClick={() => this.toggleSubMenu(index)}
                                    className={[
                                        classes.boxStyle,
                                        classes.portfolioContainer,
                                        classes.listStyle,
                                        activeIndex === index ? classes.selectedList : '',
                                        index === 0 ? classes.topRadius : classes.bottomRadius,
                                        classes.PortfolioImage
                                    ].join(' ')}
                                >
                                    <div
                                        onClick={() => {
                                            if (index === 1) {
                                                this.toggleSubMenu(index);
                                            } else {
                                                this.handleClick(index, item.path);
                                            }
                                        }}
                                        onMouseEnter={() => {
                                            if (index === 1) {
                                                this.toggleSubMenu(index);
                                            } else {
                                                //this.handleClick(index, item.path);
                                            }
                                        }}
                                    >
                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                            {activeIndex != index ?
                                                <span ></span>
                                                : <img
                                                    src={item.icon}
                                                    alt={item.label}
                                                    style={{ width: 21, height: 26, marginBottom: 12 }}
                                                />
                                            }
                                            <div>{item.label}</div>
                                        </div>
                                    </div>

                                    <div>
                                        {expandedIndex === index && item.submenus && (
                                            <ClickAwayListener onClickAway={() => this.setState({ expandedIndex: null })}>
                                                <div className={classes.navDropBox} style={{ top: -70 }}>
                                                    {item.submenus.map((sub, sidx) => (
                                                        <div
                                                            key={sidx}
                                                            className={classes.navDropBoxList}
                                                            onClick={() => this.handleTradeClick(sub.tabTitle)}
                                                        >
                                                            {sub.tabTitle || sub.label}
                                                        </div>
                                                    ))}
                                                </div>
                                            </ClickAwayListener>
                                        )}
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>

                </Router>
            </div>
        );
    }
}

export default withStyles(styles)(withRouter(FamilyReportSideMenu));
